import { ApiService } from '../../service/api/ApiService'
const companyAllAccountsSettingEndpoint = 'company/{companyOkpo}/client-bank-setting'
const createCompanyBankAccountSettingEndpoint = 'company/{companyOkpo}/bank/{bankAlias}/client-bank-setting'

const createPrivatBankAccountSetting = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  context.commit('startCreatePrivatBankSetting')
  try {
    const { data } = await ApiService.post(
      createCompanyBankAccountSettingEndpoint.replace('{bankAlias}', formData.bank_alias).replace('{companyOkpo}', formData.company.okpo),
      formData
    )
    context.commit('finishCreatePrivatBankSettingSuccess', data)
    context.commit('snackBarModules/showSuccessModal', 'Успешно сохранено', { root: true })
    return data
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('finishCreatePrivatBankSettingError')
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('fetchSettingsAccountsByCompanyOkpo', formData.company)
  }
}

const createAvalBankAccountSetting = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  context.commit('startCreateAvalBankSetting')

  const preparedData = new FormData()
  for (let key in formData) {
    preparedData.append(key, formData[key])
  }

  try {
    const { data } = await ApiService.post(
      createCompanyBankAccountSettingEndpoint.replace('{bankAlias}', formData.bank_alias).replace('{companyOkpo}', formData.company.okpo),
      preparedData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    context.commit('finishCreateAvalBankSettingSuccess', data)
    context.commit('snackBarModules/showSuccessModal', 'Успешно сохранено', { root: true })
    return data
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('finishCreateAvalBankSettingError')
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('fetchSettingsAccountsByCompanyOkpo', formData.company)
  }
}

const deleteBankAccountSetting = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  context.commit('startDeleteBankSetting')
  try {
    const { data } = await ApiService.delete(
      createCompanyBankAccountSettingEndpoint.replace('{bankAlias}', formData.bank_alias).replace('{companyOkpo}', formData.company.okpo),
      formData
    )
    context.commit('finishDeleteBankSettingSuccess')
    context.commit('snackBarModules/showSuccessModal', 'Успешно удалено', { root: true })
    return data
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('finishDeletePrivatBankSettingError')
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('fetchSettingsAccountsByCompanyOkpo', formData.company)
  }
}

const fetchSettingsAccountsByCompanyOkpo = async (context, { okpo }) => {
  context.commit('fetchSettingsAccountsByCompanyOkpo')
  try {
    const { data } = await ApiService.get(companyAllAccountsSettingEndpoint.replace('{companyOkpo}', okpo))
    const response = data === undefined ? [] : data

    const reformatResponse = Object.values(response).map((item) => {
      return { bank_name: item.bank.name, ...item }
    })
    context.commit('fetchSettingsAccountsByCompanyOkpoSuccess', reformatResponse)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchSettingsAccountsByCompanyOkpoError', error)
    return null
  }
}

export default {
  fetchSettingsAccountsByCompanyOkpo,
  createPrivatBankAccountSetting,
  deleteBankAccountSetting,
  createAvalBankAccountSetting,
}
